<template>
  <div class="help-center" v-if="!zz">
    <!-- 自助小工具 -->
    <self-service zz-sectionid="1"></self-service>
    <!-- 服务进度 -->
    <order-service-section zz-sectionid="2"></order-service-section>
    <!-- 咨询分类 -->
    <question-category zz-sectionid="3"></question-category>
  </div>
  <div v-else>
    <zz-help-center />
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import QuestionCategory from './QuestionCategory/QuestionCategoryZLJ'
import SelfService from './SelfService/SelfServiceZlj'
import OrderServiceSection from './OrderServiceSection'
import { hideShareButton, closeZljRefresh } from '../../lib/utils'

export default {
  name: 'HelpCenterZlj',
  components: {
    SelfService,
    QuestionCategory,
    OrderServiceSection,
    ZzHelpCenter: () => import('./HelpCenter')
  },
  data() {
    return {
      zz: native.in('zz') || false
    }
  },
  created() {
    hideShareButton()
    closeZljRefresh()
    native.setTitle({
      title: '客服中心'
    })
  }
}
</script>

<style lang="less" scoped>
  @import 'HelpCenter.less';
</style>
